import g from 'glamorous'

const StyledContainer = g.div(({ theme }) => {
  return {
    maxWidth: '1200px',
    width: '100%',
    margin: '0 auto'
  }
})

export default StyledContainer



// WEBPACK FOOTER //
// ./src/components/StyledContainer.tsx